const environment={apiPrefix:'https://api.backoffice.parnanoronha.nscreen.com.br/',enableMock:false};export default environment;